<div *ngIf="hasPrev" class="paging-button"
     (dragleave)="dragleavePrev()" (drop)="dragleavePrev()">
    <wbo-screen-layout-button (click)="prevPage()"
                              [item]="{itemType: ITEM_TYPE.MENU_BAR_PREV}"
                              [icon]="'chevron-left'"
                              [actionButton]="true"></wbo-screen-layout-button>
</div>
<div [draggable]="true" (dragstart)="dragstart($event, menu)" (drop)="drop($event, menu)" (dragend)="dragend()"
     class="menu-button" [ngClass]="{'toggled': menu === toggledMenu}"
     *ngFor="let menu of page"
     draggable="true">
    <wbo-screen-layout-menu-bar-button [menu]="menu"
                                       (navigated$)="navigate(menu)"
                                       [showLeftCommands]="menus.length < 21 && !(editService.$entityRestricted | async)" [showRightCommands]="menus.length > 1 && !(editService.$entityRestricted | async)"
                                       (commandsToggled$)="commandsToggled($event, menu)"></wbo-screen-layout-menu-bar-button>
</div>
<div *ngIf="hasNext" class="paging-button"
     (dragleave)="dragleaveNext()" (drop)="dragleaveNext()">
    <wbo-screen-layout-button (click)="nextPage()" [icon]="'chevron-right'"
                              [item]="{itemType: ITEM_TYPE.MENU_BAR_NEXT}"
                              [actionButton]="true"></wbo-screen-layout-button>
</div>

<div *ngIf="!hasNext && menus.length > 0 && menus.length < ScreenLayoutEditorModel.MAX_MENUS && !(editService.$entityRestricted | async)" class="paging-button">
    <wbo-screen-layout-button (click)="model.addMenu()"
                              [item]="{itemType: ITEM_TYPE.MENU_BAR_ADD}"
                              [icon]="'plus'"
                              [actionButton]="true"></wbo-screen-layout-button>
</div>
